import { createAction } from "@reduxjs/toolkit";
import { withdrawActionTypes } from "./actionTypes";

export const withdrawSuccess = createAction(
  withdrawActionTypes.success,
  (payload) => ({ payload }),
);
export const withdrawRequest = createAction(
  withdrawActionTypes.request,
  (payload) => ({ payload }),
);
export const withdrawFailure = createAction(
  withdrawActionTypes.failure,
  (payload) => ({ payload }),
);
export const resetWithdraw = createAction("payments/withdraw/reset");
